import React from "react";
import image from "../Assets/fond4.jpg";

function Logoipsum() {
  return (
    <div className={`wrapSectionPage`}>
      <div className="entetePage fond4">
        <div className="textItem">
          <h1>Logoipsum</h1>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum
            at ipsum hendrerit, suscipit diam quis, sagittis ante. Praesent
            vitae elit nunc.
          </p>
        </div>
      </div>
      <div className="rowText">
        <div className="gauche image">
          <img src={image} alt="description" />
        </div>
        <div className="droite texte">
          <h2>A happy cloud</h2>
          <hr />I spend a lot of time walking around in the woods and talking to
          trees, and squirrels, and little rabbits and stuff. Trees grow however
          makes them happy. It just happens - whether or not you worried about
          it or tried to plan it. We don't have anything but happy trees here.
          The light is your friend. Preserve it. Let's put some happy little
          clouds in our world. Don't forget to tell these special people in your
          life just how special they are to you. A big strong tree needs big
          strong roots. We need a shadow side and a highlight side. If you do
          too much it's going to lose its effectiveness.
        </div>
      </div>
      <div className="rowText">
        <div className="gauche texte">
          I spend a lot of time walking around in the woods and talking to
          trees, and squirrels, and little rabbits and stuff. Trees grow however
          makes them happy. It just happens - whether or not you worried about
          it or tried to plan it. We don't have anything but happy trees here.
          The light is your friend. Preserve it. Let's put some happy little
          clouds in our world. Don't forget to tell these special people in your
          life just how special they are to you. A big strong tree needs big
          strong roots. We need a shadow side and a highlight side. If you do
          too much it's going to lose its effectiveness.
        </div>
        <div className="droite image">
          <img src={image} alt="description" />
        </div>
      </div>
      <div className="rowText">
        <div className="centre image fond4">
          <h2>Zip. That easy.</h2>
        </div>
      </div>
      <div className="rowText">
        <div className="centre texte">
          We might as well make some Almighty mountains today as well, what the
          heck. We're trying to teach you a technique here and how to use it.
          The only thing worse than yellow snow is green snow. This is the time
          to get out all your flustrations, much better than kicking the dog
          around the house or taking it out on your spouse. There we go. It's a
          super day, so why not make a beautiful sky? If you don't like it -
          change it. It's your world. Trees grow in all kinds of ways. They're
          not all perfectly straight. Not every limb is perfect. You could sit
          here for weeks with your one hair brush trying to do that - or you
          could do it with one stroke with an almighty brush. Put it in, leave
          it alone. We'll lay all these little funky little things in there.
          Zip. That easy. The first step to doing anything is to believe you can
          do it. See it finished in your mind before you ever start. These
          little son of a guns hide in your brush and you just have to push them
          out. Use your imagination, let it go.
        </div>
      </div>
    </div>
  );
}

export default Logoipsum;
